import { useQuery } from "@tanstack/react-query";
import { getExtraHoursPaidStart } from "./constants";
import { fetchStaffPayHours, shouldRetryStaffPayRequest, STAFF_PAY_QUERY_KEY } from "./staffPayApi";

type UseStaffPayHoursParameters = {
    viewerId: string | undefined;
    userIds: Array<string>;
    selectedYear: number;
    selectedMonth: number;
    enabled: boolean;
};

export const useStaffPayHours = ({ viewerId, userIds, selectedYear, selectedMonth, enabled }: UseStaffPayHoursParameters) => {
    const { year: fromYear, month: fromMonth } = getExtraHoursPaidStart();
    const sortedUserIds = [...new Set(userIds)].sort();
    const apiMonth = selectedMonth + 1;
    const staffPayHoursQuery = useQuery({
        queryKey: [STAFF_PAY_QUERY_KEY, "hours", viewerId, sortedUserIds, fromYear, fromMonth, selectedYear, apiMonth],
        queryFn: () => fetchStaffPayHours({ userIds: sortedUserIds, fromYear, fromMonth, year: selectedYear, month: apiMonth }),
        enabled: enabled && Boolean(viewerId) && sortedUserIds.length > 0,
        retry: shouldRetryStaffPayRequest,
        refetchOnWindowFocus: false,
    });
    return staffPayHoursQuery;
};
